module.exports = __webpack_public_path__ + "static/vr-2-2-9f9132d8e162b18f71da91e12af0b867.jpeg";